import React, { useState } from "react";

import { ProposalQuoteSection } from "../../../types/proposalDocuments.types";
import { useProposalDocument } from "../proposalDocumentsContext";

import QuoteSection from "./quoteSection";
import SectionWizardModal from "./sectionWizardModal";

const Quotes: React.FC = () => {
  const { payload, setPayload, requestQuotesBulk } = useProposalDocument();
  const [showWizard, setShowWizard] = useState(false);

  const handleCreateSection = (section: ProposalQuoteSection) => {
    setPayload({
      ...payload,
      quote_sections: [...payload.quote_sections, section],
    });
  };

  const handleUpdateSection = (sIndex: number, updated: (typeof payload.quote_sections)[0]) => {
    const newSections = [...payload.quote_sections];
    newSections[sIndex] = updated;
    setPayload({ ...payload, quote_sections: newSections });
  };

  const handleRemoveSection = (sIndex: number) => {
    const newSections = [...payload.quote_sections];
    newSections.splice(sIndex, 1);
    setPayload({ ...payload, quote_sections: newSections });
  };

  return (
    <section className="quotes-section">
      <div className="quotes-section__header">
        <h2>Quotes</h2>
        <div className="quotes-section__header-actions">
          {payload.quote_sections.length > 0 && (
            <>
              <button
                type="button"
                className="quotes-section__bulk-button"
                onClick={() => {
                  requestQuotesBulk("collapse");
                }}
                aria-label="Collapse all quote sections and options"
              >
                Collapse All
              </button>
              <button
                type="button"
                className="quotes-section__bulk-button"
                onClick={() => {
                  requestQuotesBulk("expand");
                }}
                aria-label="Expand all quote sections and options"
              >
                Expand All
              </button>
            </>
          )}
          <button
            type="button"
            className="quotes-section__add-button"
            onClick={() => {
              setShowWizard(true);
            }}
            aria-label="Add new quote section"
          >
            + Add Quote Section
          </button>
        </div>
      </div>

      <SectionWizardModal
        show={showWizard}
        onClose={() => {
          setShowWizard(false);
        }}
        onCreate={handleCreateSection}
      />

      <div className="quotes-section__content">
        {payload.quote_sections.length === 0 ? (
          <div className="quotes-section__empty-state">
            <p>No quote sections yet. Click &quot;Add Quote Section&quot; to get started.</p>
          </div>
        ) : (
          <div className="quotes-section__list">
            {payload.quote_sections.map((section, sIndex) => (
              <QuoteSection
                key={sIndex}
                section={section}
                onChange={(updated) => {
                  handleUpdateSection(sIndex, updated);
                }}
                onRemove={() => {
                  handleRemoveSection(sIndex);
                }}
                sectionIndex={sIndex}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Quotes;
